import gql from 'graphql-tag';

export const getMOCEventTypes = gql`
  query getMOCEventTypes {
    getMOCEventTypes {
      id
      name
      enabled
      updater
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
`;
